import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useLaunch } from "@/context/LaunchContext";
import { useI18n } from "@/i18n";
import { fmtDuration } from "@/lib/format";

// Persistent but non-intrusive ELITE-trial banner. Live countdown from normalized trial end.
// Hidden when there is no active trial (auto-disappears when the trial expires).
export function TrialBanner() {
  const { isTrial, trialPlan, secondsRemaining } = useLaunch();
  const { lang } = useI18n();
  if (!isTrial || secondsRemaining == null) return null;
  return (
    <div data-testid="trial-banner" className="flex flex-wrap items-center justify-between gap-2 border-b border-atlas/20 bg-atlas/[0.07] px-4 py-2 lg:px-8">
      <span className="inline-flex items-center gap-2 text-sm font-semibold text-atlas-200">
        <Clock className="h-4 w-4 text-atlas-400" />
        {trialPlan} {lang === "tr" ? "Deneme" : "Trial"} · {fmtDuration(secondsRemaining, lang)} {lang === "tr" ? "kaldı" : "left"}
      </span>
      <Link to="/app/membership" data-testid="trial-banner-cta" className="rounded-full bg-atlas-500 px-3.5 py-1.5 text-xs font-bold text-atlas-ink transition hover:shadow-glow">
        {lang === "tr" ? "Planını Seç" : "Choose your plan"}
      </Link>
    </div>
  );
}
